import { Button } from './ui/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
	DropdownMenuSeparator,
	DropdownMenuLabel,
} from './ui/dropdown-menu';
import { Palette, Sun, Moon } from 'lucide-react';
import { useThemeStore, Theme } from '@/store/theme-store';

const THEMES: Record<Theme, { name: string; description: string; colors: string }> = {
	earthy: {
		name: 'Terra (Padrão)',
		description: 'Tom bege quente com acentos verde-oliva',
		colors: 'from-amber-100 via-orange-50 to-lime-100',
	},
	forest: {
		name: 'Floresta',
		description: 'Verde menta com acentos florestais',
		colors: 'from-emerald-100 via-green-50 to-teal-100',
	},
	air: {
		name: 'Ar (Branco/Preto)',
		description: 'Limpo e minimalista',
		colors: 'from-slate-100 via-gray-50 to-zinc-100',
	},
	sea: {
		name: 'Mar',
		description: 'Tons oceânicos e turquesa',
		colors: 'from-cyan-100 via-teal-50 to-sky-100',
	},
	midnight: {
		name: 'Meia-Noite',
		description: 'Azul profundo com acentos brilhantes',
		colors: 'from-blue-900 via-indigo-800 to-slate-900',
	},
};

export function ThemeSwitcher() {
	const { theme, colorMode, setTheme, toggleColorMode } = useThemeStore();

	return (
		<div className='flex items-center gap-2'>
			{/* Color Mode Toggle */}
			<Button
				variant='ghost'
				size='sm'
				onClick={toggleColorMode}
				title={colorMode === 'light' ? 'Modo escuro' : 'Modo claro'}>
				{colorMode === 'light' ? <Moon className='h-4 w-4' /> : <Sun className='h-4 w-4' />}
			</Button>

			{/* Theme Selector */}
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button variant='ghost' size='sm' title='Trocar tema'>
						<Palette className='h-4 w-4' />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align='end' className='w-64'>
					<DropdownMenuLabel>Temas Disponíveis</DropdownMenuLabel>
					<DropdownMenuSeparator />
					{Object.entries(THEMES).map(([key, { name, description, colors }]) => (
						<DropdownMenuItem
							key={key}
							onClick={() => setTheme(key as Theme)}
							className={`cursor-pointer ${theme === key ? 'bg-accent' : ''}`}>
							<div className='flex items-center gap-3 w-full'>
								<div className={`h-6 w-6 rounded-full bg-gradient-to-r ${colors} border border-gray-300`} />
								<div className='flex-1'>
									<div className='text-sm font-medium'>{name}</div>
									<div className='text-xs text-muted-foreground'>{description}</div>
								</div>
								{theme === key && (
									<div className='h-2 w-2 rounded-full bg-primary' />
								)}
							</div>
						</DropdownMenuItem>
					))}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
}
